module.exports = __webpack_public_path__ + "static/media/15.b4e38c8b.jpg";